tinymce.addI18n("is_IS", {
    "#": "",
    "Accessibility": "",
    "Accordion": "",
    "Accordion body...": "",
    "Accordion summary...": "",
    "Action": "A\xf0ger\xf0",
    "Activity": "Virkni",
    "Address": "",
    "Advanced": "\xcdtarlegt",
    "Align": "Stilla",
    "Align center": "Mi\xf0jujafna",
    "Align left": "Vinstrijafna",
    "Align right": "H\xe6grijafna",
    "Alignment": "J\xf6fnun",
    "Alignment {0}": "",
    "All": "Allt",
    "Alternative description": "",
    "Alternative source": "Valkv\xe6\xf0ur frumk\xf3\xf0i",
    "Alternative source URL": "",
    "Anchor": "",
    "Anchor...": "",
    "Anchors": "Akkeri",
    "Animals and Nature": "D\xfdr og n\xe1tt\xfara",
    "Arrows": "\xd6rvar",
    "B": "",
    "Background color": "Bakgrunnslitur",
    "Background color {0}": "",
    "Black": "Svartur",
    "Block": "Blokka",
    "Block {0}": "",
    "Blockquote": "Blokk",
    "Blocks": "Blokkir",
    "Blue": "Bl\xe1r",
    "Blue component": "",
    "Body": "Innihald",
    "Bold": "Feitletra\xf0",
    "Border": "Rammi",
    "Border color": "Litur \xe1 ramma",
    "Border style": "",
    "Border width": "",
    "Bottom": "Ne\xf0st",
    "Browse files": "",
    "Browse for an image": "Finna mynd \xed t\xf6lvunni",
    "Browse links": "",
    "Bullet list": "K\xfalu listi",
    "Cancel": "H\xe6tta vi\xf0",
    "Caption": "Titill",
    "Cell": "Reitur",
    "Cell padding": "R\xfdmi reits",
    "Cell properties": "Stillingar reits",
    "Cell spacing": "Bil \xed reit",
    "Cell styles": "",
    "Cell type": "Tegund reits",
    "Center": "Mi\xf0ja",
    "Characters": "Stafabil",
    "Characters (no spaces)": "Stafabil (engin bil)",
    "Circle": "Hringur",
    "Class": "Tegund",
    "Clear formatting": "Hreinsa sni\xf0",
    "Close": "Loka",
    "Code": "K\xf3\xf0i",
    "Code sample...": "K\xf3\xf0ad\xe6mi...",
    "Code view": "",
    "Color Picker": "Litaval",
    "Color swatch": "Litaval",
    "Cols": "D\xe1lkar",
    "Column": "D\xe1lkur",
    "Column clipboard actions": "",
    "Column group": "H\xf3pur d\xe1lks",
    "Column header": "",
    "Constrain proportions": "Halda hlutf\xf6llum",
    "Copy": "Afrita",
    "Copy column": "",
    "Copy row": "Afrita r\xf6\xf0",
    "Could not find the specified string.": "Fann ekki umbe\xf0inn streng.",
    "Could not load emojis": "",
    "Count": "Fj\xf6ldi",
    "Currency": "Gjaldmi\xf0ill",
    "Current window": "N\xfaverandi gluggi",
    "Custom color": "S\xe9rsni\xf0in litur",
    "Custom...": "S\xe9rsni\xf0i\xf0...",
    "Cut": "Skera",
    "Cut column": "",
    "Cut row": "Klippa r\xf6\xf0",
    "Dark Blue": "D\xf6kkbl\xe1r",
    "Dark Gray": "D\xf6kkgr\xe1r",
    "Dark Green": "D\xf6kkgr\xe6nn",
    "Dark Orange": "D\xf6kk appels\xednugulur",
    "Dark Purple": "D\xf6kk fj\xf3lubl\xe1r",
    "Dark Red": "D\xf6kkrau\xf0ur",
    "Dark Turquoise": "D\xf6kk gr\xe6nbl\xe1r",
    "Dark Yellow": "D\xf6kkgulur",
    "Dashed": "",
    "Date/time": "Dagur/t\xedmi",
    "Decrease indent": "Minnka inndr\xe1tt",
    "Default": "Sj\xe1lfgefi\xf0",
    "Delete accordion": "",
    "Delete column": "Ey\xf0a d\xe1lki",
    "Delete row": "Ey\xf0a r\xf6\xf0",
    "Delete table": "Ey\xf0a t\xf6flu",
    "Dimensions": "Hlutf\xf6ll",
    "Disc": "Diskur",
    "Div": "",
    "Document": "Skjal",
    "Dotted": "",
    "Double": "",
    "Drop an image here": "Settu inn mynd h\xe9r",
    "Dropped file type is not supported": "",
    "Edit": "Breyta",
    "Embed": "Hengja vi\xf0",
    "Emojis": "",
    "Emojis...": "",
    "Error": "Villa",
    "Error: Form submit field collision.": "Villa: Form submit field collision.",
    "Error: No form element found.": "Villa: Ekkert form element fannst.",
    "Extended Latin": "",
    "Failed to initialize plugin: {0}": "Val",
    "Failed to load plugin url: {0}": "Gat ekki hla\xf0i\xf0 vi\xf0b\xf3t url: {0}",
    "Failed to load plugin: {0} from url {1}": "Gat ekki hla\xf0i\xf0 vi\xf0b\xf3t: {0} fr\xe1 urli {1}",
    "Failed to upload image: {0}": "Gat ekki hala\xf0 upp mynd: {0}",
    "File": "Skjal",
    "Find": "Finna",
    "Find (if searchreplace plugin activated)": "Leita (ef searchreplace vi\xf0b\xf3t er virk)",
    "Find and Replace": "",
    "Find and replace...": "",
    "Find in selection": "",
    "Find whole words only": "Finna einungis heil or\xf0",
    "Flags": "F\xe1nar",
    "Focus to contextual toolbar": "F\xf3kus \xe1 contextual toolbar",
    "Focus to element path": "F\xf3kus \xe1 element path",
    "Focus to menubar": "F\xf3kus \xe1 menubar",
    "Focus to toolbar": "F\xf3kus \xe1 t\xe6kjastiku",
    "Font": "Leturger\xf0",
    "Font size {0}": "",
    "Font sizes": "",
    "Font {0}": "",
    "Fonts": "Leturger\xf0ir",
    "Food and Drink": "Matur og drykkur",
    "Footer": "Ne\xf0anm\xe1l",
    "Format": "Sni\xf0",
    "Format {0}": "",
    "Formats": "Sni\xf0m\xe1t",
    "Fullscreen": "Fylla skj\xe1",
    "G": "",
    "General": "Almennt",
    "Gray": "Gr\xe1r",
    "Green": "Gr\xe6nn",
    "Green component": "",
    "Groove": "",
    "Handy Shortcuts": "Sni\xf0ugar fl\xfdtilei\xf0ir",
    "Header": "Fyrirs\xf6gn",
    "Header cell": "Reitarhaus",
    "Heading 1": "Fyrirs\xf6gn 1",
    "Heading 2": "Fyrirs\xf6gn 2",
    "Heading 3": "Fyrirs\xf6gn 3",
    "Heading 4": "Fyrirs\xf6gn 4",
    "Heading 5": "Fyrirs\xf6gn 5",
    "Heading 6": "Fyrirs\xf6gn 6",
    "Headings": "Fyrirsagnir",
    "Height": "H\xe6\xf0",
    "Help": "Hj\xe1lp",
    "Hex color code": "",
    "Hidden": "",
    "Horizontal align": "",
    "Horizontal line": "L\xe1r\xe9tt l\xedna",
    "Horizontal space": "L\xe1r\xe9tt bil",
    "ID": "",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "",
    "Image is decorative": "",
    "Image list": "Myndalisti",
    "Image title": "Titill myndar",
    "Image...": "Mynd...",
    "ImageProxy HTTP error: Could not find Image Proxy": "",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "",
    "ImageProxy HTTP error: Rejected request": "",
    "ImageProxy HTTP error: Unknown ImageProxy error": "",
    "Increase indent": "Auka inndr\xe1tt",
    "Inline": "Inndregi\xf0",
    "Insert": "Setja inn",
    "Insert Template": "",
    "Insert accordion": "",
    "Insert column after": "Setja inn d\xe1lk fyrir aftan",
    "Insert column before": "Setja inn d\xe1lk fyrir framan",
    "Insert date/time": "Setja inn dagsetningu/t\xedma",
    "Insert image": "Setja inn mynd",
    "Insert link (if link plugin activated)": "Setja inn hlekk (ef link vi\xf0b\xf3t er virk)",
    "Insert row after": "Setja inn r\xf6\xf0 fyrir aftan",
    "Insert row before": "Setja inn r\xf6\xf0 fyrir framan",
    "Insert table": "Setja inn t\xf6flu",
    "Insert template...": "Setja inn sni\xf0m\xe1t...",
    "Insert video": "Setja inn myndband",
    "Insert/Edit code sample": "Setja inn/breyta k\xf3\xf0ad\xe6mi",
    "Insert/edit image": "Setja inn/breyta mynd",
    "Insert/edit link": "Setja inn/breyta hlekk",
    "Insert/edit media": "Setja inn/breyta myndefni",
    "Insert/edit video": "Setja inn/fjarl\xe6gja myndband",
    "Inset": "",
    "Invalid hex color code: {0}": "",
    "Invalid input": "",
    "Italic": "Skr\xe1letra\xf0",
    "Justify": "Jafna",
    "Keyboard Navigation": "Lyklabor\xf0 Navigation",
    "Language": "Tungum\xe1l",
    "Learn more...": "Sj\xe1 meira...",
    "Left": "Vinstri",
    "Left to right": "Vinstri til h\xe6gri",
    "Light Blue": "Lj\xf3sbl\xe1r",
    "Light Gray": "Lj\xf3sgr\xe1r",
    "Light Green": "Lj\xf3sgr\xe6nn",
    "Light Purple": "Lj\xf3s fj\xf3lubl\xe1r",
    "Light Red": "Lj\xf3srau\xf0ur",
    "Light Yellow": "Lj\xf3sgulur",
    "Line height": "",
    "Link list": "Listi hlekkja",
    "Link...": "Hlekkur...",
    "List Properties": "",
    "List properties...": "",
    "Loading emojis...": "",
    "Loading...": "",
    "Lower Alpha": "L\xe1gstafir Alpha",
    "Lower Greek": "L\xe1gstafir Gr\xedskir",
    "Lower Roman": "L\xe1gstafir R\xf3mverskir",
    "Match case": "Samanbur\xf0ur",
    "Mathematical": "St\xe6r\xf0fr\xe6\xf0i",
    "Media poster (Image URL)": "Media poster (mynd URL)",
    "Media...": "",
    "Medium Blue": "Mi\xf0lungs bl\xe1r",
    "Medium Gray": "Mi\xf0lungs gr\xe1r",
    "Medium Purple": "Mi\xf0lungs fj\xf3lubl\xe1r",
    "Merge cells": "Sameina reiti",
    "Middle": "Mi\xf0ja",
    "Midnight Blue": "N\xe6turbl\xe1r",
    "More...": "Meira...",
    "Name": "Nafn",
    "Navy Blue": "D\xf6kkbl\xe1r",
    "New document": "N\xfdtt skjal",
    "New window": "N\xfdr gluggi",
    "Next": "N\xe6sti",
    "No": "Nei",
    "No alignment": "",
    "No color": "Enginn litur",
    "Nonbreaking space": "Bil sem brotnar ekki",
    "None": "Ekkert",
    "Numbered list": "N\xfamera\xf0ur listi",
    "OR": "E\xd0A",
    "Objects": "Hlutir",
    "Ok": "Sta\xf0festa",
    "Open help dialog": "Opna hj\xe1lparkassa",
    "Open link": "",
    "Open link in...": "Opna hlekk \xed...",
    "Open popup menu for split buttons": "",
    "Orange": "Appels\xednugulur",
    "Outset": "",
    "Page break": "S\xed\xf0ubrot",
    "Paragraph": "M\xe1lsgrein",
    "Paste": "L\xedma",
    "Paste as text": "L\xedma sem texta",
    "Paste column after": "",
    "Paste column before": "",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "L\xedming er \xed textaham.  Texti ver\xf0ur l\xedmdur sem l\xe1tlaus \xfeanga\xf0 til \xfe\xfa afhakar vi\xf0 \xfeennan valm\xf6guleika.",
    "Paste or type a link": "L\xedma e\xf0a sl\xe1 inn hlekk",
    "Paste row after": "L\xedma r\xf6\xf0 fyrir aftan",
    "Paste row before": "L\xedma r\xf6\xf0 fyrir framan",
    "Paste your embed code below:": "L\xedma frumk\xf3\xf0a fyrir ne\xf0an:",
    "People": "F\xf3lk",
    "Plugins": "Vi\xf0b\xe6tur",
    "Plugins installed ({0}):": "Uppsettar vi\xf0b\xf3tir ({0}):",
    "Powered by {0}": "Keyrt af {0}",
    "Pre": "\xd3st\xedla\xf0",
    "Preferences": "Stillingar",
    "Preformatted": "",
    "Premium plugins:": "Premium vi\xf0b\xe6tur:",
    "Press the Up and Down arrow keys to resize the editor.": "",
    "Press the arrow keys to resize the editor.": "",
    "Press {0} for help": "",
    "Preview": "Forsko\xf0un",
    "Previous": "Fyrri",
    "Print": "",
    "Print...": "Prenta...",
    "Purple": "Fj\xf3lubl\xe1r",
    "Quotations": "Tilvitnanir",
    "R": "",
    "Range 0 to 255": "",
    "Red": "Rau\xf0ur",
    "Red component": "",
    "Redo": "Endurkalla",
    "Remove": "",
    "Remove color": "Fjarl\xe6gja lit",
    "Remove link": "Fjarl\xe6gja hlekk",
    "Replace": "Skipta \xfat",
    "Replace all": "Skipta \xf6llum \xfat",
    "Replace with": "Skipta \xfat me\xf0",
    "Resize": "Breyta st\xe6r\xf0",
    "Restore last draft": "Endurkalla s\xed\xf0asta uppkast",
    "Reveal or hide additional toolbar items": "",
    "Rich Text Area": "",
    "Rich Text Area. Press ALT-0 for help.": "Rich Text sv\xe6\xf0i. Smelltu \xe1 Alt-0 fyrir hj\xe1lp",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Textasv\xe6\xf0i \xed \xedtarham.  \xddttu \xe1 ALT-F9 fyrir valmynd.  \xddttu \xe1 ALT-F10 fyrir t\xf3lastiku.  \xddttu \xe1 ALT-0 fyrir a\xf0sto\xf0.",
    "Ridge": "",
    "Right": "H\xe6gri",
    "Right to left": "H\xe6gri til vinstri",
    "Row": "R\xf6\xf0",
    "Row clipboard actions": "",
    "Row group": "H\xf3pur ra\xf0ar",
    "Row header": "",
    "Row properties": "Stillingar ra\xf0ar",
    "Row type": "Tegund ra\xf0ar",
    "Rows": "Ra\xf0ir",
    "Save": "Vista",
    "Save (if save plugin activated)": "Vista (ef vistunar vi\xf0b\xf3t er virk)",
    "Scope": "Gildissvi\xf0",
    "Search": "Leita",
    "Select all": "Velja allt",
    "Select...": "Velja...",
    "Selection": "Val",
    "Shortcut": "Fl\xfdtilei\xf0",
    "Show blocks": "S\xfdna kubba",
    "Show caption": "S\xfdna myndatexta",
    "Show invisible characters": "S\xfdna \xf3s\xfdnilega stafi",
    "Size": "St\xe6r\xf0",
    "Solid": "",
    "Source": "Sl\xf3\xf0i",
    "Source code": "Frumk\xf3\xf0i",
    "Special Character": "",
    "Special character...": "S\xe9rstakur stafur...",
    "Split cell": "Deila reiti",
    "Square": "Ferningur",
    "Start list at number": "",
    "Strikethrough": "Yfirstrika\xf0",
    "Style": "St\xedll",
    "Subscript": "Ni\xf0urskrifa\xf0",
    "Superscript": "Uppskrift",
    "Switch to or from fullscreen mode": "Skipta \xed e\xf0a \xfar fullum skj\xe1",
    "Symbols": "T\xe1kn",
    "System Font": "Kerfis leturger\xf0",
    "Table": "Tafla",
    "Table caption": "",
    "Table properties": "Stillingar t\xf6flu",
    "Table styles": "",
    "Template": "Sni\xf0m\xe1t",
    "Templates": "Sni\xf0m\xe1t",
    "Text": "Texti",
    "Text color": "Litur texta",
    "Text color {0}": "",
    "Text to display": "Texti til a\xf0 s\xfdna",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "Hlekkurinn sem \xfe\xfa rita\xf0ir inn l\xfdtur \xfat fyrir a\xf0 vera netfang. Viltu b\xe6ta vi\xf0 forskeytinu mailto: ?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "Hlekkurinn sem \xfe\xfa rita\xf0ir inn l\xfdtur \xfat fyrir a\xf0 vera ytri hlekkur. Viltu b\xe6ta vi\xf0 forskeytinu http:// ?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "",
    "Title": "Titill",
    "To open the popup, press Shift+Enter": "\xddttu \xe1 Shift+Enter til a\xf0 opna sprettiglugga",
    "Toggle accordion": "",
    "Tools": "T\xf3l",
    "Top": "Efst",
    "Travel and Places": "Fer\xf0al\xf6g og sta\xf0ir",
    "Turquoise": "Gr\xe6nbl\xe1r",
    "Underline": "Undirstrika\xf0",
    "Undo": "Afturkalla",
    "Upload": "Hla\xf0a upp",
    "Uploading image": "",
    "Upper Alpha": "H\xe1stafir Alpha",
    "Upper Roman": "H\xe1stafir R\xf3mverskir",
    "Url": "Veffang",
    "User Defined": "Stillt af notanda",
    "Valid": "Gilt",
    "Version": "\xdatg\xe1fa",
    "Vertical align": "",
    "Vertical space": "L\xf3\xf0r\xe9tt bil",
    "View": "Sko\xf0a",
    "Visual aids": "Sj\xf3nr\xe6n hj\xe1lp",
    "Warn": "A\xf0vara",
    "White": "Hv\xedtur",
    "Width": "Breidd",
    "Word count": "Or\xf0afj\xf6ldi",
    "Words": "Or\xf0",
    "Words: {0}": "Or\xf0:  {0}",
    "Yellow": "Gulur",
    "Yes": "J\xe1",
    "You are using {0}": "\xde\xfa ert a\xf0 nota {0}",
    "You have unsaved changes are you sure you want to navigate away?": "\xdea\xf0 eru \xf3vista\xf0ar breytingar, ertu viss um a\xf0 \xfe\xfa viljir vafra \xed burtu?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "Vafrinn \xfeinn sty\xf0ur ekki beinann a\xf0gang a\xf0 klippibor\xf0inu.  Nota\xf0u Ctrl-X/C/V \xe1 lyklabor\xf0inu \xed sta\xf0inn.",
    "alignment": "textastilling",
    "austral sign": "austral t\xe1kn",
    "cedi sign": "cedi t\xe1kn",
    "colon sign": "kommu t\xe1kn",
    "cruzeiro sign": "cruzeiro t\xe1kn",
    "currency sign": "gjaldmi\xf0ils t\xe1kn",
    "dollar sign": "dollar t\xe1kn",
    "dong sign": "dong t\xe1kn",
    "drachma sign": "drachma t\xe1kn",
    "euro-currency sign": "evru-gjaldmi\xf0ils t\xe1kn",
    "example": "d\xe6mi",
    "formatting": "",
    "french franc sign": "franskur franki t\xe1kn",
    "german penny symbol": "german penny t\xe1kn",
    "guarani sign": "guarani t\xe1kn",
    "history": "saga",
    "hryvnia sign": "hryvnia t\xe1kn",
    "indentation": "inndr\xe1ttur",
    "indian rupee sign": "indverskt rupee t\xe1kn",
    "kip sign": "kip t\xe1kn",
    "lira sign": "lira t\xe1kn",
    "livre tournois sign": "livre tournois t\xe1kn",
    "manat sign": "manat t\xe1kn",
    "mill sign": "mill t\xe1kn",
    "naira sign": "naira t\xe1kn",
    "new sheqel sign": "new sheqel t\xe1kn",
    "nordic mark sign": "nordic mark t\xe1kn",
    "peseta sign": "peseta t\xe1kn",
    "peso sign": "peso t\xe1kn",
    "ruble sign": "ruble t\xe1kn",
    "rupee sign": "rupee t\xe1kn",
    "spesmilo sign": "spesmilo t\xe1kn",
    "styles": "st\xedlar",
    "tenge sign": "tenge t\xe1kn",
    "tugrik sign": "tugrik t\xe1kn",
    "turkish lira sign": "tyrknesk l\xedra t\xe1kn",
    "won sign": "won t\xe1kn",
    "yen character": "yen stafur",
    "yen/yuan character variant one": "yen/yuan t\xe1kn afbrig\xf0i eitt",
    "yuan character": "yuan stafur",
    "yuan character, in hong kong and taiwan": "yuan stafur, \xed Hong Kong og Ta\xedvan",
    "{0} characters": "{0} stafabil",
    "{0} columns, {1} rows": "",
    "{0} words": "{0} or\xf0"
});